<div class="flex flex-col flex-center gap-20" [class.gap-32]="config()?.isModalView">
  <div class="flex flex-col flex-center text-center gap-16">
    <app-svg-icon name="forgot-password"></app-svg-icon>
    <div class="flex flex-col gap-8">
      @if (!config()?.isModalView) {
        <div class="text-font-1 text-color-2 text-20 font-weight-700" [innerHTML]="'t.account-access-restricted' | translate | safe: 'html'"></div>
      }
      <div class="text-16 font-weight-400" [innerHTML]="'t.account-locked-desc' | translate: {type: config().descriptionType | translate | lowercase} | safe: 'html'" (click)="onProcessLink($event)"></div>
    </div>
  </div>

  <div class="flex flex-col gap-16 w-100">
    <button class="btn btn--secondary w-100" (click)="ze.open()">{{ 't.contact-us' | translate }}</button>
    @if (!config()?.isModalView) {
      <button class="btn btn--tertiary w-100" (click)="logout()">{{ 't.logout' | translate }}</button>
    }
  </div>
</div>
